import React from 'react';

import DynamicImage from '@reverbdotcom/commons/src/components/dynamic_image';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { listingItemPagePath } from '@reverbdotcom/commons/src/url_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { WEB } from '@reverbdotcom/commons/src/constants';
import { Listing } from '@reverbdotcom/commons/src/rql';

import QuickPriceEditButton, {
  VALID_LISTING_STATES_FOR_QUICK_PRICE_EDIT,
} from '../listings/quick_price_edit/quick_price_edit_button';
import SellerListingCardDetails from './SellerListingCardDetails';
import SellerListingCardFooter from './SellerListingCardFooter';

interface IExternalProps {
  listing: Listing;
}

export default function SellerListingCard({ listing }: IExternalProps) {
  const user = useUser();
  const openNewTab = user && user.deviceName === WEB;

  return (
    <div className="seller-listing-card">
      <div className="seller-listing-card__content">
        <div className="seller-listing-card__content__image">
          <CoreLink
            to={listingItemPagePath(listing)}
            target={openNewTab ? '_blank' : undefined}
          >
            <DynamicImage
              src={listing.images[0].source}
              imageBox="fullWidth"
            />
          </CoreLink>
        </div>

        <div className="width-100">
          <div className="seller-listing-card__content__details-header">
            <CoreLink
              to={listingItemPagePath(listing)}
              target={openNewTab ? '_blank' : undefined}
            >
              {listing.title}
            </CoreLink>
            <QuickPriceEditButton
              listingId={listing.id}
              defaultSellerPrice={listing.sellerPrice}
              showQuickPriceEditPopover={false}
              userUuid={listing.sellerUuid}
              isEditable={VALID_LISTING_STATES_FOR_QUICK_PRICE_EDIT.includes(listing.state)}
            />
          </div>

          <SellerListingCardDetails listing={listing} />
        </div>
      </div>

      <SellerListingCardFooter listing={listing} />
    </div>
  );
}
